import { Button } from './Button'
import type { TDefaultButtonProps } from './Button.type'

export { Button, TDefaultButtonProps }
